module.exports = __webpack_public_path__ + "img/airev-logo.33867f54.svg";